import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './error-pages.scss';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="error-page">
      <div className="error-page__card">
        <div className="error-page__brand">RealityCoach</div>

        <div className="error-page__code error-page__code--blue">404</div>

        <h1 className="error-page__title">{t('errorPages.pageNotFound')}</h1>

        <p className="error-page__description">
          {t('errorPages.notFoundDescription')}
        </p>

        <div className="error-page__actions">
          <button className="error-page__btn-primary" onClick={() => navigate('/')}>
            {t('errorPages.goToDashboard')}
          </button>
          <button className="error-page__btn-secondary" onClick={() => navigate(-1)}>
            {t('common.goBack')}
          </button>
        </div>

        <p className="error-page__footer">{t('errorPages.notFoundCode')}</p>
      </div>
    </div>
  );
};

export default NotFoundPage;
